import { z } from 'zod';

import { emailSchema, idSchema, isoDateSchema } from './common.schema';

export const userRoleSchema = z.enum(['owner', 'admin', 'supervisor', 'operator']);
// Тип UserRole — единый источник истины в status-machine/ticket-state-machine.
// Здесь только schema для валидации zod'ом, иначе барyel-конфликт.

export const userStatusSchema = z.enum(['online', 'busy', 'away', 'offline']);
export type UserStatus = z.infer<typeof userStatusSchema>;

export const userSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  name: z.string().min(1).max(200),
  email: emailSchema,
  avatar_url: z.string().url().nullable().optional(),
  role: userRoleSchema,
  status: userStatusSchema,
  is_active: z.boolean(),
  two_fa_enabled: z.boolean(),
  languages: z.array(z.string()).default([]),
  specialization: z.array(z.string()).default([]),
  locale: z.string().min(2).max(8),
  last_login_at: isoDateSchema.nullable().optional(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type User = z.infer<typeof userSchema>;

export const inviteOperatorSchema = z.object({
  email: emailSchema,
  name: z.string().min(1).max(200).optional(),
  role: userRoleSchema.default('operator'),
  group_ids: z.array(idSchema).optional(),
  languages: z.array(z.string()).optional(),
  specialization: z.array(z.string()).optional(),
});

export const updateUserSchema = z
  .object({
    name: z.string().min(1).max(200),
    avatar_url: z.string().url().nullable(),
    role: userRoleSchema,
    is_active: z.boolean(),
    languages: z.array(z.string()),
    specialization: z.array(z.string()),
    /** Разрешённые источники (типы каналов) для приёма тикетов. [] = все. */
    allowed_sources: z.array(z.string()),
    locale: z.string().min(2).max(8),
    working_hours: z.record(z.unknown()),
  })
  .partial();

export const passwordSchema = z
  .string()
  .min(12)
  .max(255)
  .refine((v) => /[a-z]/.test(v) && /[A-Z]/.test(v) && /[0-9]/.test(v), {
    message: 'password must contain lowercase, uppercase, and digit',
  });

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1).max(255),
  workspace_slug: z.string().optional(),
  totp_code: z
    .string()
    .regex(/^\d{6}$/)
    .optional(),
  backup_code: z.string().min(8).max(64).optional(),
});

export const changePasswordSchema = z.object({
  current_password: z.string().min(1).max(255),
  new_password: passwordSchema,
});
